(() => {
  const STORAGE_KEY = 'ho-whatsapp-contact-dismissed-v1';

  const initialize = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const closeButton = root.querySelector('[data-ho-whatsapp-close]');
    const links = root.querySelectorAll('[data-ho-whatsapp-link]');
    const delay = Math.max(0, Number(root.dataset.delay || 3)) * 1000;
    const showBubble = root.dataset.showBubble !== 'false';
    let dismissed = false;

    try {
      dismissed = window.sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (_error) {
      dismissed = false;
    }

    const open = () => {
      if (!showBubble) return;
      root.classList.add('is-open');
    };

    const close = (remember = false) => {
      root.classList.remove('is-open');

      if (!remember) return;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, 'true');
      } catch (_error) {
        // The widget remains functional when browser storage is unavailable.
      }
    };

    if (!dismissed && showBubble) {
      window.setTimeout(open, delay);
    }

    closeButton?.addEventListener('click', () => close(true));

    const mainButton = root.querySelector('.ho-whatsapp-contact__button');
    mainButton?.addEventListener('mouseenter', open);
    mainButton?.addEventListener('focus', open);

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close(false);
        mainButton?.focus();
      }
    });

    links.forEach((link) => {
      link.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'helgaora_whatsapp_click',
          placement: link.dataset.hoWhatsappPlacement || 'floating-widget'
        });
      });
    });
  };

  const initializeAll = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches('[data-ho-whatsapp]')) initialize(scope);
    scope.querySelectorAll?.('[data-ho-whatsapp]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
